/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Conversation_BodyInputs */

const en_us2_search_preview_conversation_body = /** @type {(inputs: Search_Preview_Conversation_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers cite the studies they rest on.`)
};

const pt_br2_search_preview_conversation_body = /** @type {(inputs: Search_Preview_Conversation_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As respostas citam os estudos em que se baseiam.`)
};

const es_419_search_preview_conversation_body = /** @type {(inputs: Search_Preview_Conversation_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las respuestas citan los estudios en los que se basan.`)
};

const pt_pt2_search_preview_conversation_body = /** @type {(inputs: Search_Preview_Conversation_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As respostas citam os estudos em que se baseiam.`)
};

const fr_fr2_search_preview_conversation_body = /** @type {(inputs: Search_Preview_Conversation_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les réponses citent les études sur lesquelles elles reposent.`)
};

const de_de2_search_preview_conversation_body = /** @type {(inputs: Search_Preview_Conversation_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Antworten nennen die Studien, auf denen sie beruhen.`)
};

const it_it2_search_preview_conversation_body = /** @type {(inputs: Search_Preview_Conversation_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le risposte citano gli studi su cui si basano.`)
};

/**
* | output |
* | --- |
* | "Answers cite the studies they rest on." |
*
* @param {Search_Preview_Conversation_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_conversation_body = /** @type {((inputs?: Search_Preview_Conversation_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Conversation_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_conversation_body(inputs)
	if (locale === "es-419") return es_419_search_preview_conversation_body(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_conversation_body(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_conversation_body(inputs)
	if (locale === "de-DE") return de_de2_search_preview_conversation_body(inputs)
	if (locale === "it-IT") return it_it2_search_preview_conversation_body(inputs)
	return en_us2_search_preview_conversation_body(inputs)
});
export { search_preview_conversation_body as "search.preview_conversation_body" }